<li
  class="Item_Container"
  >
  <a
    class="Item_Content"
    [ngClass]="{'is-selected': isSelected(id)}"
    (click)="handleClick($event)"
    >
    <div class="Item_Icon">
      <img [src]="image" />
    </div>
    @if (novoMenu) {
      <label class="novo-menu" >
        novo
      </label>
    }
    <label class="Item_Title">
      {{ name }}
    </label>
  </a>
</li>